import React from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { LoginForm, RegisterForm } from '../../components/auth';
import Button from '../../components/ui/Button';
import Card from '../../components/ui/Card';
import logoSvg from '../../assets/weaversworld-logo.svg';
import './AuthView.css';

/**
 * Auth view component for displaying various authentication screens
 */
const AuthView = () => {
  const { action } = useParams();
  const navigate = useNavigate();
  
  const renderAuthContent = () => {
    switch (action) {
      case 'login':
        return <LoginForm />;
      case 'signup':
        return <RegisterForm />;
      case 'confirm-email':
        return (
          <Card className="auth-view__verify-email">
            <div className="auth-view__verify-email-icon">📧</div>
            <h2 className="auth-view__verify-email-title">Verify Your Email Address</h2>
            <p className="auth-view__verify-email-message">
              We've sent an email to verify your address. Please check your inbox and follow
              the link in the email to complete your registration.
            </p>
            <p className="auth-view__verify-email-message">
              If you don't see the verification email in your main inbox, check your spam folder.
              The email should arrive within a few minutes.
            </p>
            <div className="auth-view__back-button">
              <Button
                variant="outlined"
                onClick={() => navigate('/')}
              >
                Return to Home
              </Button>
            </div>
          </Card>
        );
      default:
        // Redirect to login if action not recognized
        navigate('/accounts/login', { replace: true });
        return null;
    }
  };
  
  return (
    <div className="auth-view">
      <div className="auth-view__logo">
        <Link to="/">
          <img 
            src={logoSvg} 
            alt="Weaver's World"
          />
        </Link>
      </div>
      <div className="auth-view__container">
        {renderAuthContent()}
      </div>
    </div>
  );
};

export default AuthView;